import { render, staticRenderFns } from "./OrderDeliveryDetailModal.vue?vue&type=template&id=cc3f7d1c&"
import script from "./OrderDeliveryDetailModal.vue?vue&type=script&lang=js&"
export * from "./OrderDeliveryDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./OrderDeliveryDetailModal.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports